import { render, staticRenderFns } from "./joinpreview.vue?vue&type=template&id=1135cda3&scoped=true&"
import script from "./joinpreview.vue?vue&type=script&lang=js&"
export * from "./joinpreview.vue?vue&type=script&lang=js&"
import style0 from "./joinpreview.vue?vue&type=style&index=0&id=1135cda3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1135cda3",
  null
  
)

export default component.exports